module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    class: ['vheader', {
      showAnimate: _vm.show
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenuButton),
      expression: "showMenuButton"
    }],
    staticClass: "left",
    on: {
      "click": _vm.showMenu
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackButton),
      expression: "showBackButton"
    }],
    staticClass: "left",
    on: {
      "click": _vm.handleBackButton
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.showMenuButton == false) && (_vm.showBackButton == false)),
      expression: "(showMenuButton==false)&&(showBackButton==false)"
    }],
    staticClass: "left",
    on: {
      "click": _vm.showMenu
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "text",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPostButton),
      expression: "showPostButton"
    }],
    staticClass: "right",
    on: {
      "click": _vm.goPost
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPostButton),
      expression: "!showPostButton"
    }],
    staticClass: "right"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50e2753c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = 138
// module chunks = 1